<script setup>
import { computed, ref } from "vue";
import { useLinkify } from "../../../../widget/composables/useLinkify.js";
import LinksguardDialog from "../../../../widget/components/ui-components/LinksguardDialog.vue";

const props = defineProps({
    forms: Object,
    theme: Object
})

const { linkifyHtml } = useLinkify();

const hasDescription = computed(() => !!props.forms.description.replace(/<\/?[^>]+(>|$)/g, ''))
const linkifiedDescription = computed(() => linkifyHtml(props.forms.description, props.theme.color))

const linksguardUrl = ref(null);
const linksguardVisible = ref(false);

function handleClick(event) {
    const anchor = event.target.closest('a[data-linksguard]');
    if (anchor) {
        event.preventDefault();
        linksguardUrl.value = anchor.dataset.linksguard;
        linksguardVisible.value = true;
    }
}
</script>

<template>
    <section id="basic-data" class="flex flex-col" :class="theme.logo_url ? 'lg:pt-4' : ''">
        <p class="text-lg font-bold" :class="`!text-${theme.color}-500`">{{ forms.users.name }}</p>
        <p class="text-2xl font-bold" :class="hasDescription ? 'mb-4' : ''" v-html="forms.name"></p>
        <div
            v-if="hasDescription"
            class="opacity-80 prose dark:prose-invert dark:opacity-90"
            v-html="linkifiedDescription"
            @click="handleClick"
        ></div>

        <linksguard-dialog v-model:visible="linksguardVisible" :url="linksguardUrl"></linksguard-dialog>
    </section>
</template>
